<template>
  <!-- 首页第一块 -->
  <div class="mcont1">
    <div class="mcont1-bg">
      <div class="item-block">
        <!-- 第一行 - 左侧 - 图片 -->
        <img :src="smstar" style="max-width: 25%;height:auto;margin-left: 10%;">

        <!-- 第一行 - 右侧 - 文字信息 -->
        <div class="item-block_msg">
          <p class="msg-title">{{ title }}</p>
          <ul class="msg-content">
            <li>{{ firstContent1 }}</li>
            <li>{{ firstContent12 }}</li>
            <li>{{ firstContent2 }}</li>
          </ul>
        </div>
      </div>

      <div class="item-block bottom">
        <!-- 第二行 - 左侧 - 文字信息 -->
        <div class="item-block_msg">
          <p class="msg-title" style="font-size:1.8rem;font-weight:bold;color:#000;">
            {{ title2 }}
          </p>
          <p class="msg-content">{{ secondContent1 }}</p>
        </div>
        <!-- 第二行 - 右侧 - 图片 -->
        <img :src="lgstar">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      smstar: require('@/assets/images/new/work-classify.png'),
      bod: require('@/assets/images/commition/part2_picture3.png'),
      lgstar: require('@/assets/images/new/work-flow.png'),
    }
  },
  computed: {
    title() {
      return this.$store.getters.currentLang === 'zh' ? '系统开发的特征' : 'システム開発の特徴'
    },
    firstContent1() {
      return this.$store.getters.currentLang === 'zh' ? '灵活运用业务知识和IT专业知识，系统咨询为标准装备；' : '業務知識やITの専門知識を活かしたシステムコンサルティングを標準装備'
    },
    firstContent12() {
      return this.$store.getters.currentLang === 'zh' ? '风险较低的极简开发(敏捷模型开发)；' : 'リスクの低いシンプルな開発(アジャイルモデル開発) '
    },
    firstContent2() {
      return this.$store.getters.currentLang === 'zh' ? '提供网络和硬件的建议、从系统开发到维护的“多合一”服务；' : 'ネットワークやハードウエアの提案、システム開発からメンテナンスまでの「マルチインワン」サービスを提供します'
    },
    title2() {
      return this.$store.getters.currentLang === 'zh' ? 'IT解决方案系统开发事业' : 'ITソリューションシステム開発事業'
    },
    secondContent1() {
      return this.$store.getters.currentLang === 'zh' ? '我们通过利用业务知识进提案，从系统开发、基础设施建设，到现场系统运营和维护，为经营所有的过程提供令客户满意的服务和解决方案 ' : 'システム開発からインフラ構築、現場のシステム運用・保守まで、業務知識を活かした提案を通じて、経営のすべてのプロセスにおいてお客様に満足していただけるサービスとソリューションを提供しています'
    }
  }
}
</script>

<style scoped lang="scss">
// 内容模块一
.mcont1 {
  width: 100%;
  // height: 640px;
  background: $write;

  &-bg {
    margin: 0 auto;
    margin-top: 6%;
    width: 70%;
    height: inherit;
    position: relative;
    background: url(../../assets/images/commition/part2_picture3.png) no-repeat;
    background-size: 48%;
    background-position: 10% 30%;

    .item-block {
      display: flex;
      justify-content: space-between;

      &_msg {
        margin-left: 25%;

        .msg-title {
          font-size: 1.8rem;
          font-weight: 700;
          color: #000;
        }

        .msg-content {
          font-size: 1.4rem;
          font-weight: 400;
          color: #8f8f8f;
          >li {
            margin-left: 20px;
            list-style: unset;
          }
        }
      }

      >img {
        width: 100%;
        object-fit: contain;
      }
    }

    .bottom {
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
      margin-top: 10%;
      >img {
        width: 60%;
      }

      .item-block_msg {
        min-width: 30%;
        text-align: left;
        margin: 0 2% 4% 0;
      }
    }
  }
}
</style>


